import React from "react";

function MobileFilterButton({ onClick }) {
    return(
        <div className="filter__button-toggle" onClick={onClick}>
            <div className="filter__icon"></div>
            <div className="filter__text">Фільтр</div>
        </div>
    )
}

export default MobileFilterButton;